export const GET_SIDEBAR_CONTENT =
  'global/hooks/useRightSidebar/getSidebarContent'

export const GET_STACKHOLDER_SURVEYS =
  'global/hooks/useRightSidebar/getStackHolderSurveys'
